"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Team = void 0;
/**
 * List of team
 * @enum {string}
 */
let Team = exports.Team = /*#__PURE__*/function (Team) {
  Team["Checkout"] = "Checkout";
  Team["Growth"] = "Growth";
  Team["Presentation"] = "Presentation";
  Team["OrderManagement"] = "OrderManagement";
  Team["Payment"] = "Payment";
  Team["Acquisition"] = "Acquisition";
  Team["Framework"] = "Framework";
  Team["Backend"] = "Backend";
  Team["SellingTools"] = "SellingTools";
  Team["AcquisitionGrowth"] = "AcquisitionGrowth";
  return Team;
}({});
//# sourceMappingURL=Team.js.map